export default __webpack_public_path__ + "static/media/bootstrap.2c2f834a.png";